import React from 'react';
import classNames from 'classnames';
import { isBlank } from 'helpers/string_helpers';

type Props = {
  children?: React.ReactNode;
  imageUrl?: string;
  subtitle?: string;
  title: string;
};

export default function TitleBar({ children, imageUrl, subtitle, title }: Props) {
  const headerClass = classNames({
    'py-4': true,
    'with-image': !isBlank(imageUrl),
  });

  const titleClass = classNames({
    'h5': true,
    'pe-4 border-end': !isBlank(subtitle),
  });

  return (
    <div className={headerClass}>
      <div className="container">
        <div className="d-flex align-items-center gap-4">
          <div>
            {!isBlank(imageUrl) && (
              <img className="d-none d-md-inline" src={imageUrl} />
            )}
          </div>
          <span className={titleClass}>
            {title}
          </span>
          {!isBlank(subtitle) && (
            <div className="d-none d-md-inline fs-large">
              {subtitle}
            </div>
          )}
          {children && (
            <div className="ms-auto">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
